export default "__VITE_ASSET__3e5532b8__"